module.exports = __webpack_public_path__ + "static/media/pathImg.62d57946.jpg";